export class Remittance {
    constructor(
        public Prescription_PrescriptionNumber: string,
        public Prescription_FillDate: Date,
        public Location_NCPDPProviderIdentifier: string,
        public Location_NationalProviderIdentifier: string,
        public Location_CorporateLocationNumber: string,
        public Payer_ProcessorIdentifier: string,
        public Payer_ShardPayerName: string,
        public Payer_ShardPayerGroupIdentifier: number,
        public RawDataImport_ReceivedDate: Date,
        public AREngine_UnappliedCashCategory: number,
        public Money_PaidAmount: number,
        public AREngine_UnappliedAmount: number,
        public Money_PaymentStatusCode: number,
        public Payment_Batch_Sequence: string,
        public Payment_ReferenceNumber: number,
        public Adj_Code: boolean = true,
        public HasAuditHistory: boolean,
        public IsRelatedItem: boolean) {
        }
}



// WEBPACK FOOTER //
// ./src/app/models/remittance.model.ts